import { render, staticRenderFns } from "./Orden.vue?vue&type=template&id=352db19a&scoped=true&"
import script from "./Orden.vue?vue&type=script&lang=js&"
export * from "./Orden.vue?vue&type=script&lang=js&"
import style0 from "./Orden.vue?vue&type=style&index=0&id=352db19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352db19a",
  null
  
)

export default component.exports